import { useQuery } from 'react-query'
import axios from 'axios'
import { serializeQuery } from './utils'

const ENDPOINT = 'api/eco-stock'
const QUERY_KEY = 'eco-stocklist'

export const useGetEcoAllStock = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'detail', 'all'],
    async () => (await axios.get(`${ENDPOINT}/all`)).data,
    config
  )

export const useGetEcoStockList = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'list', query],
    async () => (await axios.get(serializeQuery(ENDPOINT, query))).data,
    config
  )

export const useGetEcoItemId = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'item', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/item`, query))).data,
    config
  )
